import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const NoAvailabilityPrompt = ({ onSubmit }: { onSubmit: () => void }) => {
  return (
    <Card sx={{ maxWidth: 600, mt: 2 }}>
      <CardContent sx={{ padding: 1.5, textAlign: "center" }}>
        <Typography variant="h5" pb={2} fontWeight={600}>
          Thank you for choosing Ognomy Sleep
        </Typography>
        <Typography>
          Thank you for choosing Ognomy Sleep for your sleep health needs. While
          we don't currently have a sleep specialist in your area, please
          complete your registration and we'll reach out as soon as one becomes
          available.
        </Typography>
      </CardContent>
      <Box sx={{ padding: 2 }}>
        <Button fullWidth variant="contained" sx={{ mb: 1 }} onClick={onSubmit}>
          Continue Registering
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={() => window.location.assign("https://www.ognomy.com")}
        >
          Leave For Now
        </Button>
      </Box>
    </Card>
  );
};

export default NoAvailabilityPrompt;
